// EditItem.jsx
import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ItemContext } from "./ItemContext";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { FaStar, FaRegStar } from "react-icons/fa";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const EditItem = () => {
  const { selectedItem, updateItem } = useContext(ItemContext);
  const navigate = useNavigate();
  const [editedItem, setEditedItem] = useState(selectedItem);
  const [userCategories, setUserCategories] = useState([]);
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    if (!selectedItem) {
      navigate("/"); // Redirect to items list if item data is not available
    }
  }, [selectedItem, navigate]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists() && userDoc.data().categories) {
          setUserCategories(userDoc.data().categories);
        } else {
          // Existing users predating the categories feature have no
          // categories field on their doc yet - fall back to the same
          // defaults ManageCategories seeds new users with.
          setUserCategories(["Home", "Work"]);
        }
      }
    });
    return () => unsubscribe();
  }, [auth, db]);

  const handleChange = (e) => {
    setEditedItem({ ...editedItem, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (user) {
      const userId = user.uid;
      const addressId = editedItem.id;
      await updateItem(userId, addressId, editedItem);
    } else {
      console.log("No user is signed in.");
    }
    navigate("/addresses"); // Redirect to the address list after saving
  };

  const handleCancel = () => {
    navigate("/addresses"); // Back to the address list on cancel
  };

  return (
    <div
      className="container"
      style={{
        width: "80%",
        maxWidth: "400px",
        margin: "auto",
        paddingTop: "calc(20px + env(safe-area-inset-top, 0px))",
      }}
    >
      <h2>Edit Address</h2>
      <input
        type="text"
        name="Title"
        value={editedItem?.Title || ""}
        onChange={handleChange}
        placeholder="Title"
        style={{
          width: "90%",
          padding: "10px 15px",
          marginBottom: "10px",
          borderRadius: "20px",
          border: "1px solid var(--border-color, #ccc)",
        }}
      />
      <input
        type="text"
        name="Address"
        value={editedItem?.Address || ""}
        onChange={handleChange}
        placeholder="Address"
        style={{
          width: "90%",
          padding: "10px 15px",
          marginBottom: "10px",
          borderRadius: "20px",
          border: "1px solid var(--border-color, #ccc)",
        }}
      />
      <select
        name="category"
        value={editedItem?.category || ""}
        onChange={handleChange}
        style={{
          width: "94%",
          padding: "10px",
          marginBottom: "10px",
          borderRadius: "20px",
          border: "1px solid var(--border-color, #ccc)",
        }}
      >
        <option value="">No Category</option>
        {userCategories.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>
      <textarea
        name="notes"
        value={editedItem?.notes || ""}
        onChange={handleChange}
        placeholder="Notes (e.g. gate code, parking instructions)"
        rows={3}
        style={{
          width: "90%",
          padding: "10px",
          marginBottom: "10px",
          borderRadius: "20px",
          border: "1px solid var(--border-color, #ccc)",
          paddingLeft: "15px",
          fontFamily: "inherit",
          resize: "vertical",
        }}
      />
      <button
        type="button"
        onClick={() =>
          setEditedItem({ ...editedItem, isFavorite: !editedItem?.isFavorite })
        }
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
          marginBottom: "15px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          color: "#f5a623",
        }}
      >
        {editedItem?.isFavorite ? (
          <FaStar size={20} />
        ) : (
          <FaRegStar size={20} />
        )}
        <span style={{ color: "#333" }}>
          {editedItem?.isFavorite ? "Favorited" : "Mark as favorite"}
        </span>
      </button>
      <br />
      <button
        onClick={handleSave}
        style={{
          padding: "10px 30px",
          border: "none",
          cursor: "pointer",
          borderRadius: "5px",
          backgroundColor: "#4CAF50",
          color: "white",
          marginRight: "20px",
        }}
      >
        Save
      </button>
      <button
        onClick={handleCancel}
        style={{
          backgroundColor: "gray",
          color: "white",
          padding: "10px 15px",
          border: "none",
          cursor: "pointer",
          borderRadius: "5px",
        }}
      >
        Cancel
      </button>
    </div>
  );
};

export default EditItem;
